// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__36mo1","colCheckbox":"styles_colCheckbox__1iTo6"};